import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-294" data-mp="2wzyv6qk4tooq">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-295" data-mp="2szyc2sm38pbc">
        <SectionHeading eyebrow="📦 What's inside" title="6 premium volumes that turn scattered notes into one clinical workflow" data-id="element-296" data-mp="2szew3hg00azy" />

        <div className="mt-10 flex flex-col gap-5" data-id="element-297" data-mp="2j9likawaplt2">
          {volumes.map(volume => <article key={volume.number} className="rounded-3xl border border-navy-100 bg-cream p-5 sm:p-8" data-id="element-298" data-mp="2ea8vpq5fceqh">
              <div className="flex flex-col gap-4 md:flex-row md:gap-8" data-id="element-299" data-mp="299mb6hbm41hs">
                <div className="md:w-2/5" data-id="element-300" data-mp="258sp7thqcwrj">
                  <span className="inline-block rounded-lg bg-navy-800 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-301" data-mp="20b0wix99h6ma">
                    {volume.number}
                  </span>
                  <h3 className="mt-3 font-display text-2xl font-black uppercase leading-tight text-navy-800 sm:text-3xl" data-id="element-302" data-mp="37w2t2xev6ba1">
                    {volume.title}
                  </h3>
                  <p className="mt-2 text-base font-bold text-sky-600" data-id="element-303" data-mp="2u34smwnkdszm">
                    {volume.tagline}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-navy-600 sm:text-base" data-id="element-304" data-mp="3lvm2dtjevsnx">
                    {volume.description}
                  </p>
                </div>

                <div className="md:w-3/5" data-id="element-305" data-mp="3cvfr8eb6r4rx">
                  <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-navy-400" data-id="element-306" data-mp="3cue4vdopyvuw">
                    Inside you’ll find
                  </p>
                  <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-307" data-mp="21gacud1ozhsh">
                    {volume.items.map(item => <li key={item} className="flex items-start gap-2 rounded-xl bg-white px-3 py-2.5 text-sm font-semibold text-navy-700" data-id="element-308" data-mp="26gerdxj1i2g2">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" aria-hidden="true" data-id="element-309" data-mp="71d5blonwik0" />
                        <span data-id="element-310" data-mp="3udxp4kvsfpvy">{item}</span>
                      </li>)}
                  </ul>
                  {volume.note ? <p className="mt-3 flex gap-2 text-xs leading-relaxed text-navy-500" data-id="element-311" data-mp="3pbyohirfn72p">
                      <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-312" data-mp="3kh1f2aq8qvpa" />
                      {volume.note}
                    </p> : null}
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-313" data-mp="19n6qnf00699x">
          <CTAButton label="Get all 6 volumes for $27" data-id="element-314" data-mp="19notiuh67lqt" />
        </div>
      </div>
    </section>;
}